import { Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { SECTION_NAMES, TEMPLATE_NAMES } from "src/app/constants";
import { ApiService } from "src/app/services/api.service";
import { ThemeService } from "src/app/services/themes.service";
import { TitleUpdateService } from "src/app/services/title-update.service";
import { environment } from "src/environments/environment";

@Component({
    selector: 'app-itc-consulting-page',
    templateUrl: './itc-consulting-page.component.html',
    styleUrls: ['./itc-consulting-page.component.scss']
})

export class ITCConsultingPageComponent implements OnInit {

    themedata: any;
    fontData: any;
    cuttingEdgeTechnologiesHeading: any;
    cuttingEdgeTechnologiesPoints: any;
    boldSolutionsHeading: any;
    boldSolutionsPoints: any;
    ourGoalsHeading: any;
    ourGoalsPoints: any;
    cloudComputingSolutionsHeading: any;
    cloudComputingSolutionsPoints: any;
    transformYourFutureHeading: any;
    transformYourFuturePoints: any;

    constructor(
        private themeService: ThemeService,
        private spinnerService: NgxSpinnerService,
        private apiService: ApiService,
        private titleUpdateService: TitleUpdateService,
    ) { }

    ngOnInit(): void {
        this.themeService.theme$.subscribe((response) => {
            this.themedata = response;
        });

        this.themeService.selectedFont$.subscribe((response) => {
            this.fontData = response;
        });

        this.loadPageData();
        this.titleUpdateService.setTitleFromRoute();
    }

    loadPageData() {
        this.spinnerService.show();
        if (environment.LOAD_LOCAL_DATA) {
            this.apiService.getITCHomePageDataFromJSONFile().subscribe((response: any) => {
                this.cuttingEdgeTechnologiesHeading = response[`${TEMPLATE_NAMES.ITC_HOME}_${SECTION_NAMES.CUTTING_EDGE_TECHNOLOGIES_HEADING}`];
                this.cuttingEdgeTechnologiesPoints = response[`${TEMPLATE_NAMES.ITC_HOME}_${SECTION_NAMES.CUTTING_EDGE_TECHNOLOGIES_POINTS}`];
                this.boldSolutionsHeading = response[`${TEMPLATE_NAMES.ITC_HOME}_${SECTION_NAMES.BOLD_SOLUTIONS_HEADING}`];
                this.boldSolutionsPoints = response[`${TEMPLATE_NAMES.ITC_HOME}_${SECTION_NAMES.BOLD_SOLUTIONS_POINTS}`];
                this.ourGoalsHeading = response[`${TEMPLATE_NAMES.ITC_HOME}_${SECTION_NAMES.OUR_GOALS_HEADING}`];
                this.ourGoalsPoints = response[`${TEMPLATE_NAMES.ITC_HOME}_${SECTION_NAMES.OUR_GOALS_POINTS}`];
                this.cloudComputingSolutionsHeading = response[`${TEMPLATE_NAMES.ITC_HOME}_${SECTION_NAMES.CLOUD_COMPUTING_SOLUTION_HEADING}`];
                this.cloudComputingSolutionsPoints = response[`${TEMPLATE_NAMES.ITC_HOME}_${SECTION_NAMES.CLOUD_COMPUTING_SOLUTION_POINTS}`];
                this.transformYourFutureHeading = response[`${TEMPLATE_NAMES.ITC_HOME}_${SECTION_NAMES.TRANSFORM_YOUR_FUTURE_HEADING}`];
                this.transformYourFuturePoints = response[`${TEMPLATE_NAMES.ITC_HOME}_${SECTION_NAMES.TRANSFORM_YOUR_FUTURE_POINTS}`];
            });
        }

        this.spinnerService.hide();
    }
}